import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { GuidelineService } from '../../services/guideline.service';
import { setClassInvalid } from '../../shared/functions';
import { guidelineDepartments, ee, urlRegexp } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-guideline-form',
  templateUrl: './add-guideline-form.component.html',
  standalone: false
})
export class AddGuidelineFormComponent {
  private guidelineService = inject(GuidelineService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  addGuidelineForm = this.createGuidelineForm();
  guidelineDepartments = guidelineDepartments;
  urlRegexp = urlRegexp;
  setClassInvalid = setClassInvalid;

  createGuidelineForm(): UntypedFormGroup {
    return this.formBuilder.group({
      title: ['', [Validators.required]],
      department: ['', [Validators.required]],
      url: ['', Validators.pattern(/^https?:\/\/.*/)],
      pinned: [false, [Validators.required]],
    });
  }

  addGuideline(): void {
    this.guidelineService.add(this.addGuidelineForm.value)
      .pipe(finalize(() => {
        ee.emit('getGuidelines');
        ee.emit('guidelineAdded', true);
      }))
      .subscribe({
        next: res => this.toast.setMessage('Guideline added successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }

}
